import {Injectable} from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class EnvService {

  bulk_payments_access = [];
  bulk_transactions_access = [];
  bulk_users_access = [];
  bulk_claim_access = [];
  bulk_claim_status_access = [];

  sim_socket_connect = false;
  supervisor_socket_connect = false;
  ussdgw_socket_connected = false;

  set_profile_test = false;
  profile_test = '';
  roles = {};
  captcha_key = '6Ldz3TcaAAAAANuhZ-NgSt16Csyjqc5PUoh2eekj';

  constructor() {
  }

  bool;

  check_role(type, role, balance = 0) {
    const a = this[type].filter((i) => {
      if (type === 'bulk_payments_access') {
        return i.role === role && balance >= i.limit;

      }
      return i.role === role;
    });

    return a.length > 0;
  }
}
